import styled from '@emotion/styled';

import { ScrollArea } from '~/ui/core/scroll-area/ScrollArea';

export const ContentContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing['4xl'],
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
    padding: theme.spacing['4xl'],
    paddingBottom: 0,
}));

export const ScrollContentContainer = styled(ContentContainer)({
    overflow: 'unset',
});

export const StickyContentViewport = styled.div({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    minWidth: 0,
});

export const StickyContentContainer = styled(StickyContentViewport)({
    overflow: 'auto',
});

export const StickyScrollArea = styled(ScrollArea)({
    flex: 1,
    minHeight: 0,
    minWidth: 0,
});

export const Header = styled.div(({ theme }) => ({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
}));

export const StickyHeader = styled(Header)(({ theme }) => ({
    backgroundColor: theme.colors.white[200],
    padding: `${theme.spacing['4xl']} ${theme.spacing['4xl']} ${theme.spacing.l}`,
    position: 'sticky',
    top: 0,
    zIndex: 100,
}));

export const StickyContentBody = styled.div(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing['4xl'],
    minHeight: 0,
    minWidth: 0,
    padding: theme.spacing['4xl'],
    paddingBottom: 0,
}));

export const HeaderTop = styled.div({
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
});

export const TitleGroup = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.m,
}));

export const TitleRow = styled.div(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing.xl,
}));

export const Title = styled.h2(({ theme }) => ({
    ...theme.typography.headline.h4.medium,
    color: theme.colors.gray[900],
    margin: 0,
}));

export const Description = styled.p(({ theme }) => ({
    ...theme.typography.body.S.regular,
    color: theme.colors.gray[700],
    margin: 0,
    marginTop: theme.spacing.m,
}));

export const ButtonGroup = styled.div(({ theme }) => ({
    button: {
        overflow: 'hidden',
    },
    display: 'flex',
    gap: theme.spacing.m,
}));

export const RightControlsGroup = styled.div(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing.m,
}));

export const SidebarMenuItem = styled.button<{ readonly isActive: boolean }>(({ isActive, theme }) => ({
    '@media (hover: hover) and (pointer: fine), (any-hover: hover) and (any-pointer: fine)': {
        '&:hover': {
            backgroundColor: theme.colors.gray[100],
        },
        transition: 'background-color 200ms ease, border-left-color 200ms ease, font-weight 200ms ease',
    },
    ...theme.typography.body.S.regular,
    alignItems: 'center',
    background: 'transparent',
    backgroundColor: isActive ? theme.colors.gray[100] : 'transparent',
    border: 'none',
    borderRadius: theme.borderRadius.m,
    color: isActive ? theme.colors.orange[800] : theme.colors.gray[900],
    cursor: 'pointer',
    display: 'flex',
    fontWeight: theme.typography.body.S.medium.fontWeight,
    gap: theme.spacing.m,
    justifyContent: 'space-between',
    padding: `${theme.spacing.m} ${theme.spacing.l}`,
    textAlign: 'left',
    width: '100%',
}));
